<div class="container">

  <h1 class="mt-2">Users</h1>

  <span class="me-2 mb-2">Reload users:</span>
  <button mat-mini-fab color="primary" (click)="fetchKeycloakUsers()">
    <mat-icon>refresh</mat-icon>
  </button>

  <div class="row">
    <p-table
      #dt
      [value]="keycloakUsers()"
      [sortMode]="'multiple'"
      [scrollable]="true" scrollHeight="var(--explorer-grid-height)"
      [tableStyle]="{ 'min-width': '50rem' }"
      styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th id="userName" style="min-width:10rem" pSortableColumn="userName" pResizableColumn>
            {{ 'PROFILE' | translate }}
          </th>
          <th id="firstName" style="min-width:2rem" pSortableColumn="firstName" pResizableColumn>
            {{ 'FIRSTNAME' | translate }}
          </th>
          <th id="lastName" style="min-width:10rem" pSortableColumn="lastName" pResizableColumn>
            {{ 'LASTNAME' | translate }}
          </th>
          <th id="email" style="min-width:10rem" pSortableColumn="email" pResizableColumn>
            {{ 'EMAIL.EMAIL' | translate }}
          </th>
          <th id="action" style="min-width:7rem" pSortableColumn="action" pResizableColumn>
          </th>
        </tr>

      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.username }}</td>
          <td>{{ item.firstName }}</td>
          <td>{{ item.lastName }}</td>
          <td>{{ item.email }}</td>
          <td>
            <button mat-icon-button type="button" class="" title="Edit job" (click)="toEditPage(item.keycloakId)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button type="button" class="" title="Edit job" (click)="delete(item.keycloakId, item.username)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="pt-4">
      <button mat-flat-button color="primary" class="mt-0" (click)="createNew()"
              *hasPermission="Permission.USER_CREATE">
          <mat-icon>add</mat-icon>
          {{ 'CREATE' | translate }}
      </button>
  </div>
</div>
